import NoteIndex from "@p/note/NoteIndex";

export const noteRootPages = {
  path: '/note',
  name: 'note_index_route',
  component: NoteIndex
}
